import React from 'react'
import { withRouter } from './Routing';

class GlobalHistory extends React.Component {
    componentDidMount() {
        window.goToPage = this.goToPage.bind(this);
        window.getProp = this.getProp.bind(this);
    }

    goToPage(page) {
        const pathname = this.props.router.location.pathname;
        if (pathname.slice(1) != page) {
            this.props.router.navigate(page);
        }
    }

    getProp(name) {
        return this.props[name];
    }

    render() {
        return null
    }
}

export default withRouter(GlobalHistory);